module.exports = __webpack_public_path__ + "img/product-placeholder-72.0a8016f.png";